/**
*
* Disclaimer: Source code mentioned below is(are) Intellectual Property of
* Crayon Data Holdings Limited (including its subsidiaries and affiliates).
* Crayon Data Holdings Limited reserves right to own and control it the way
* it may deem fit. You must refrain from use, access, read, modify, add or
* delete, sell or use in any other package or programme pertaining to such
* source code without explicit prior written approval of
* Crayon Data Holding Limited. Breach of the same shall attract penalty as
* applicable.
*
*/

// MenuBar Component
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

// Constant
import { menuBarTitle } from "../../constants";
import uiConfig from "../../uiConfig";

export default class MenuBar extends PureComponent {
  state = {
    width: 0
  };

  static get propTypes() {
    return {
      activeMenu: PropTypes.string,
      onChangeTab: PropTypes.func
    };
  }

  static get defaultProps() {
    return {
      activeMenu: "",
      onChangeTab: null
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  /* OnClick Function */
  _onChangeTab = (id) => {
    const { onChangeTab } = this.props;
    if (onChangeTab) {
      onChangeTab(id);
    }
  };

  /* Other Render Function */
  _renderTitle(title, id, action, disable) {
    const { activeMenu } = this.props;
    const cls = {
      mnu: true,
      "mnu-act": id === activeMenu
    };

    return (
      <div
        className={`${clsx(cls)} p-0 ${action} ${disable}`}
        style={disable?uiConfig.config.whitelabel.components.menubar.side_menu_inactive:id === activeMenu?uiConfig.config.whitelabel.components.menubar.side_menu_active:uiConfig.config.whitelabel.components.menubar.side_menu}
        onClick={() => this._onChangeTab(id)}
      >
        {title}
      </div>
    );
  }

  _renderTitleMobile(title, id, action, disable) {
    const { activeMenu } = this.props;
    const cls = {
      mnu: true,
      "mnu-act": id === activeMenu
    };

    return (
      <div
        className={`${clsx(cls)} p-0 ${action} ${disable}`}
        onClick={() => this._onChangeTab(id)}
      >
        <div className="title-mbl">{title}</div>
      </div>
    );
  }

  /* Main Render Functions */
  render() {
    const minWidth = 768;
    if (minWidth >= this.state.width) {
      return (
        <div className="col-md-12 p-0 mt-15 menubar-div-mbl">
          {this._renderTitleMobile(
            menuBarTitle.bestOffers,
            "bestOffers",
            "top",
            ""
          )}
          {this._renderTitleMobile(menuBarTitle.info, "info", "", "")}
          {this._renderTitleMobile(
            menuBarTitle.menu,
            "menu",
            "",
            "menu-disable"
          )}
          {this._renderTitleMobile(
            menuBarTitle.reviews,
            "reviews",
            "",
            "menu-disable"
          )}
          {this._renderTitleMobile(
            menuBarTitle.orderOnline,
            "orderOnline",
            "",
            "menu-disable"
          )}
          {this._renderTitleMobile(
            menuBarTitle.bookTable,
            "bookTable",
            "",
            "menu-disable"
          )}
          {this._renderTitleMobile(
            menuBarTitle.photos,
            "photos",
            "bottom",
            "menu-disable"
          )}
        </div>
      );
    }
    return (
      <div className="col-md-12 p-0 menubar-div">
        {this._renderTitle(menuBarTitle.bestOffers, "bestOffers", "top", "")}
        {this._renderTitle(menuBarTitle.info, "info", "", "")}
        {this._renderTitle(menuBarTitle.menu, "menu", "", "menu-disable")}
        {this._renderTitle(menuBarTitle.reviews, "reviews", "", "menu-disable")}
        {this._renderTitle(
          menuBarTitle.orderOnline,
          "orderOnline",
          "",
          "menu-disable"
        )}
        {this._renderTitle(
          menuBarTitle.bookTable,
          "bookTable",
          "",
          "menu-disable"
        )}
        {this._renderTitle(
          menuBarTitle.photos,
          "photos",
          "bottom",
          "menu-disable"
        )}
      </div>
    );
  }
}
